<template lang="html">

  <section class="sala-de-prensa">
    <h1>sala-de-prensa Component</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'sala-de-prensa',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped >
  .sala-de-prensa {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/sala-de-prensa.vue